import { Spacing, Text, Title } from '@vkontakte/vkui';
import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';
import { isCurrentDarkTheme } from 'reactApp/modules/theme/theme.selectors';
import { sendDwh } from 'reactApp/utils/ga';

import styles from './TrialOnboardingBenefitsModal.css';
import {
    cloudBenefits,
    getBenefitImageUrl,
    mailBenefits,
    TRIAL_ONBOARDING_STATIC_URL,
    useTrialSpaceValue,
} from './TrialOnboardingBenefitsModal.helpers';
import type { BenefitsProps, TrialOnboardingBenefitsModalProps } from './TrialOnboardingBenefitsModal.types';

const BenefitsItem: React.FC<BenefitsProps> = ({ img, text }) => {
    return (
        <div className={styles.benefitsBlock}>
            <img src={img} alt="Преимущество" className={styles.benefitsImage} />
            <Text className={styles.benefitsText}>{text}</Text>
        </div>
    );
};

const ContentComponent = () => {
    const isDark = useSelector(isCurrentDarkTheme);

    return (
        <>
            <img className={styles.tag} src={`${TRIAL_ONBOARDING_STATIC_URL}/trialOnboardingInfoTag.png`} alt="Подключено" />
            <div className={styles.content}>
                <Title level={'3'}>В Облаке</Title>
                <Spacing size={16} />
                <div className={styles.benefitsList}>
                    {cloudBenefits.map((item) => (
                        <BenefitsItem key={item.text} img={getBenefitImageUrl(item.img, isDark)} text={item.text} />
                    ))}
                </div>
                <Spacing size={16} />
                <Title level={'3'}>В Почте</Title>
                <Spacing size={16} />
                <div className={styles.benefitsList}>
                    {mailBenefits.map((item) => (
                        <BenefitsItem key={item.text} img={getBenefitImageUrl(item.img, isDark)} text={item.text} />
                    ))}
                </div>
            </div>
        </>
    );
};

const EVENT_CATEGORY = 'trial-onboarding-benefits-modal';

export const TrialOnboardingBenefitsModal: React.FC<TrialOnboardingBenefitsModalProps> = ({ onClose }) => {
    const spaceValue = useTrialSpaceValue();

    useEffect(() => {
        sendDwh({
            eventCategory: EVENT_CATEGORY,
            action: 'show',
        });
    }, []);

    const handleClick = useCallback(() => {
        sendDwh({
            eventCategory: EVENT_CATEGORY,
            action: 'click',
        });
        onClose();
    }, [onClose]);

    const handleClose = useCallback(() => {
        sendDwh({
            eventCategory: EVENT_CATEGORY,
            action: 'close',
        });
        onClose();
    }, [onClose]);

    return (
        <WhatsNewDialog
            // eslint-disable-next-line no-irregular-whitespace
            title={`Что есть в подписке Mail Space кроме ${spaceValue}`}
            content={<ContentComponent />}
            className={styles.root}
            imageUrl=""
            hideImage
            closable
            closeAfterClick
            closeOnDimmerClick
            primaryButtonText="Отлично"
            primaryButtonClassName={styles.button}
            onClick={handleClick}
            onClose={handleClose}
        />
    );
};
